export const LIST = "AGENT_DEPOSIT_LISTING";
export const DETAILS = "AGENT_DEPOSIT_DETAILS";
export const UPDATE = "AGENT_DEPOSIT_UPDATE";